import { httpClient } from '@/infrastructure/api/httpClient';
import type { CourseRepository } from '@/domain/port/CourseRepository';
import type { Course } from '@/domain/model/Course';

export class CourseApiAdapter implements CourseRepository {
  async getCourse(id: string): Promise<Course> {
    const response = await httpClient.get<Course>(`/courses/${id}`);
    return response.data;
  }

  async getCoursesByChapter(chapterId: string): Promise<Course[]> {
    const response = await httpClient.get<Course[]>(`/courses/chapter/${chapterId}`);
    return response.data;
  }
}
